// extracted by mini-css-extract-plugin
module.exports = {"button":"_2zRIAh","shine-lines":"_25OgHu"};